import {Component, Inject, OnInit} from '@angular/core';
import {ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle} from '@angular/material/dialog';
import {Cycle} from '@services/model/cycle';
import {CyclesComponent} from '@ma-dashboard/cycles/cycles.component';
import moment from 'moment';
import {MarkantElementsModule} from '@markant/elements-angular';
import {MatFormField} from '@angular/material/form-field';
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from '@angular/material/datepicker';
import {MatInput} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';

@Component({
  selector: 'app-cycle-edit',
  templateUrl: './cycle-edit.component.html',
  styleUrls: ['./cycle-edit.component.scss'],
  standalone: true,
  imports: [
    // this MatSelectModule is currently needed, even though the linter may not realize it.
    MatSelectModule,

    ReactiveFormsModule,
    MarkantElementsModule,
    MatFormField,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatDatepicker,
    MatInput,
    MatDialogActions,
    MatDialogTitle,
    MatDialogContent,
  ],
})
export class CycleEditComponent implements OnInit {
  cycleForm = new UntypedFormGroup({
    name: new UntypedFormControl('', [Validators.required]),
    description: new UntypedFormControl(''),
    location: new UntypedFormControl('', [Validators.required]),
    applicationStart: new UntypedFormControl('', [Validators.required]),
    applicationEnd: new UntypedFormControl('', [Validators.required]),
    votingStart: new UntypedFormControl('', [Validators.required]),
    votingEnd: new UntypedFormControl('', [Validators.required]),
    feedback: new UntypedFormControl('', [Validators.required]),
    pitchDate: new UntypedFormControl('', [Validators.required]),
    publishStart: new UntypedFormControl('', [Validators.required]),
    // publishEnd: new FormControl('', [Validators.required]),
  });

  /* MOST IMPORTANT RESPONSIBILITY: Take our UTC times, make them editable as local times, and then turn them back into UTC times */

  constructor(
    private readonly dialogRef: MatDialogRef<CyclesComponent>,
    @Inject(MAT_DIALOG_DATA) protected readonly cycle: Cycle | null,
  ) {}

  ngOnInit() {
    if (this.cycle) {
      this.cycleForm.setValue({
        name: this.cycle.name,
        description: this.cycle.description,
        location: this.cycle.location,
        applicationStart: this.cycle.applicationStart.local(),
        applicationEnd: this.cycle.applicationEnd.local(),
        votingStart: this.cycle.votingStart.local(),
        votingEnd: this.cycle.votingEnd.local(),
        feedback: this.cycle.feedback.local(),
        pitchDate: this.cycle.pitchDate, // pitchDate is a nominal day, not a timestamp, ergo no local/utc business
        publishStart: this.cycle.publishStart.local(),
        // publishEnd: this.cycle.publishEnd
      });
    }
  }

  saveForm(): void {
    if (!this.cycleForm.valid) {
      console.log('could no validate');
      return;
    }
    const c: Cycle = {
      uuid: this.cycle ? this.cycle.uuid : null,
      name: this.f.name.value,
      description: this.f.description.value,
      location: this.f.location.value,
      applicationStart: moment(this.f.applicationStart.value).hour(0).minute(0).utc(),
      applicationEnd: moment(this.f.applicationEnd.value).hour(23).minute(59).second(59).utc(),
      votingStart: moment(this.f.votingStart.value).hour(0).minute(0).utc(),
      votingEnd: moment(this.f.votingEnd.value).hour(23).minute(59).second(59).utc(),
      feedback: moment(this.f.feedback.value).hour(0).minute(0).utc(),
      pitchDate: moment(this.f.pitchDate.value).hour(0).minute(0),
      publishStart: moment(this.f.publishStart.value).hour(0).minute(0).utc(),
      publishEnd: moment('2100-01-01 23:59:59').utc(), // this.f.publishEnd.value
    };
    this.dialogRef.close(c);
  }

  get f(): any {
    return this.cycleForm.controls;
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
